export default "__VITE_ASSET__Da1k5nvt__"